import * as React from 'react';
import {
    DateField,
    FunctionField,
    Labeled,
    TextField,
    useRecordContext,
    useTranslate,
    SimpleShowLayout,
    BooleanField,
    Loading
} from 'react-admin';
import { Grid, Typography } from '@mui/material';

import { OrderReturn } from '../../types';
import { returnStates } from './returnStates';

const OrderReturnDetails = () => {
    const record = useRecordContext<OrderReturn>();
    const t = useTranslate();
    const empty = t(`resources.order.show.none`);

    if (!record) {
        return <Loading/>;
    }

    return (
        <SimpleShowLayout record={record} sx={{width: "100%"}}>
            <Typography variant="h6" gutterBottom>
                {t('resources.order.return.detailsHeadline')}
            </Typography>
            <Grid container>
                <Grid item xs={12} sm={6} md={4}>
                    <Labeled
                        source="number"
                        label={`resources.order.return.fields.number`}
                    >
                        <TextField source="number" />
                    </Labeled>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Labeled
                        source="createdAt"
                        label={`resources.order.return.fields.createdAt`}
                    >
                        <DateField
                            source="createdAt"
                            showTime={true}
                            locales="de-DE"
                            options={{
                                dateStyle: 'medium',
                                timeStyle: 'short',
                            }}
                        />
                    </Labeled>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    {record.selectLineDocumentId && (
                        <Labeled
                            source="selectLineDocumentId"
                            label={`resources.order.return.fields.selectLineDocumentId`}
                        >
                            <TextField source="selectLineDocumentId" emptyText={empty} />
                        </Labeled>
                    )}
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Labeled
                        source="isFullReturn"
                        label={`resources.order.return.fields.isFullReturn`}
                    >
                        <BooleanField source="isFullReturn" />
                    </Labeled>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Labeled
                        source="shippingReturn"
                        label={`resources.order.return.fields.shippingReturn`}
                    >
                        <BooleanField source="shippingReturn" />
                    </Labeled>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Labeled
                        source="itemsToReturn"
                        label={`resources.order.return.fields.itemsToReturn`}
                    >
                        <TextField source="itemsToReturn" emptyText={empty} />
                    </Labeled>
                </Grid>
                {record.returnConcerns && (
                    <Grid item xs={12}>
                        <Labeled
                            source="returnConcerns"
                            label={`resources.order.return.fields.returnConcerns`}
                        >
                            <TextField source="returnConcerns" emptyText={empty} />
                        </Labeled>
                    </Grid>
                )}
                {record.declineReasonNote && (
                    <Grid item xs={12}>
                        <Labeled
                            source="declineReasonNote"
                            label={`resources.order.return.fields.declineReasonNote`}
                        >
                            <TextField source="declineReasonNote" emptyText={empty} />
                        </Labeled>
                    </Grid>
                )}
            </Grid>
        </SimpleShowLayout>
    );
};

export default OrderReturnDetails;
